import isNumber from "lodash/isNumber";
import mapValues from "lodash/mapValues";
import { minutesToHours } from "PFCore/helpers/calendars";
import { DurationMode, HistoryAvailability, StandardRange } from "PFTypes";

const formatDurationValue = (value: number, mode?: DurationMode) =>
  mode === DurationMode.Hours ? minutesToHours(value, "h") : value;

const formatDayOfWeekValue = (value: number[]) =>
  value.map((minutes) => (isNumber(minutes) ? minutesToHours(minutes, "h") : "-"));

// Falls back to (`after` ?? `before`) only when the diff omits `duration.mode` (mode didn't change)
const getRangeDurationMode = (
  availability: HistoryAvailability | undefined,
  index: number
): DurationMode | undefined => {
  if (!availability) {
    return undefined;
  }

  const availabilityRule =
    "ranges" in availability ? availability : (availability.after ?? availability.before);

  return (availabilityRule?.ranges?.[index] as StandardRange)?.duration?.mode;
};

export const sanitizeAvailabilityRange = (
  range: Record<string, any>,
  index: number,
  availability?: HistoryAvailability
) => {
  const sanitized = { ...range };

  if (sanitized.duration?.value) {
    const currentMode = getRangeDurationMode(availability, index);
    const [prevMode, nextMode] = sanitized.duration.mode ?? [currentMode, currentMode];

    sanitized.duration = {
      ...sanitized.duration,
      value: [
        formatDurationValue(sanitized.duration.value[0], prevMode),
        formatDurationValue(sanitized.duration.value[1], nextMode)
      ]
    };
  }

  if (sanitized.dayOfWeek) {
    sanitized.dayOfWeek = mapValues(sanitized.dayOfWeek, formatDayOfWeekValue);
  }

  return sanitized;
};
